export default {
  bookExperiencePanel: 'Panel de reserva de experiencia',
  calendarIcon: 'Ícono de calendario',
  coverImageForResource: 'Imagen de portada para experiencias {{title}}',
  filterBy: 'Filtrar por {{filter}}',
  filterByDateRange: 'Filtrar por rango de fechas',
  gallery: 'Galería',
  goBack: 'Volver a la página anterior',
  hostUserIcon: 'Ícono de usuario anfitrión',
  imageOf: 'Imagen de {{title}}',
  interactiveMapAltText: 'Mapa interactivo con selección de {{title}}',
  mediaSlides: 'Diapositivas de medios',
  muteVideo: 'Silenciar video',
  nextPhoto: 'Foto siguiente',
  noVideoPlayback: 'Sin capacidad de reproducción de video',
  pauseVideo: 'Pausar video',
  photoOf: 'Foto de {{name}}',
  playVideo: 'Reproducir video',
  previousPhoto: 'Foto anterior',
  moreFiltersAndExperiences: 'Más filtros y experiencias',
  reserveSelectedSlot: 'Reservar franja horaria seleccionada',
  reviewRating: 'Calificación de la reseña {{rating}} de 5',
  overallReviewRating: 'Calificación general de las reseñas {{rating}} de 5',
  selectCountryCodeForPhoneNumber:
    'Seleccionar código de país para número de teléfono',
  selectDate: 'Seleccionar fecha',
  selectParticipants: 'Seleccionar participantes',
  selectSessionTime: 'Seleccionar hora de la sesión',
  unmuteVideo: 'Activar sonido del video',
  viewShoppingCart: 'Ver carrito',
  itemsInCart: '{{count}} artículos en el carrito',
  zoomIn: 'Acercar',
  zoomOut: 'Alejar',
  selectData: 'Seleccionar {{data}}',
  reserveName: 'Reservar {{name}',
  deleteReservation: 'Eliminar la reserva de {{experienceTitle}}',
  editParticipantsFor: 'Editar participantes para {{experienceTitle}}',
  increaseAddOnAmount: 'Aumentar {{addOn}} seleccionado',
  decreaseAddOnAmount: 'Disminuir {{addOn}} seleccionado',
  addOnModal: '{{addOn}} modal',
  moreInformationAboutAddOn: 'Más información sobre {{addOn}}',
  viewFullDetailsDescription: 'Ver descripción completa de los detalles',
  viewFullDescription: 'Ver descripción completa',
  closeModal: 'Cerrar modal',
  hyattBanner: 'Banner exclusivo para miembros de World of Hyatt',
  hyattBannerDesc:
    'Banner promocional que indica beneficios y ofertas exclusivas disponibles para los miembros del programa de fidelidad World of Hyatt',
  previousSlide: 'Slide anterior',
  nextSlide: 'Slide siguiente',
  paginationBulletMessage: 'Ir al slide',
  exitFullscreen: 'Salir del modo de pantalla completa',
  enterFullscreen: 'Entrar en modo de pantalla completa',
  videoSlide: 'Slide de video',
  imageSlide: 'Slide de imagen',
  of: 'de',
  noDescription: 'Sin descripción',
  mediaGallery: 'Carrousel - Galería de medios',
  dateSelector: 'Selector de fecha',
  nextWeek: 'Próxima semana',
  previousWeek: 'Semana anterior',
  scheduleAgenda: 'Agenda del calendario',
  scheduleNav: 'Navegación del calendario',
  scheduleViewSelector: 'Selector de vista del calendario',
  selectedDateAriaLabel: '{{date}}, seleccionado',
  tapToBookExperience: 'Reservar {{title}}',
  bookExperienceAriaLabel: 'Reservar {{title}}',
  joinWaitlistAriaLabel: 'Unirse a la lista de espera para {{title}}',
};
